/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum QuestionnaireAliases {
  LAYOUT_CONTEXTUALBAR_CONTENT = 'layout-contextualbar-content',
  QUESTIONNAIRE_CONTEXTUAL_BAR = 'questionnaire-contextual-bar',
  QUESTIONNAIRE_DYNAMIC_FIELDS = 'questionnaire-dynamic-fields',
  QUESTIONNAIRE_FETCH = 'questionnaire-fetch',
  QUESTIONNAIRE_FORM = 'questionnaire-form',
  QUESTIONNAIRE_LAYOUT = 'questionnaire-layout',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { QuestionnaireAliases };
